import { render } from "./EmailDetails.vue?vue&type=template&id=576c5b50&scoped=true"
import script from "./EmailDetails.vue?vue&type=script&lang=js"
export * from "./EmailDetails.vue?vue&type=script&lang=js"

import "./EmailDetails.vue?vue&type=style&index=0&id=576c5b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576c5b50"]])

export default __exports__